// Static table definitions used for client-side availability simulation
export const tables = [
  { id: 1, seats: 2, location: 'Terrace' },
  { id: 2, seats: 2, location: 'Indoor' },
  { id: 3, seats: 4, location: 'Indoor' },
  { id: 4, seats: 4, location: 'Terrace' },
  { id: 5, seats: 6, location: 'Indoor' },
  { id: 6, seats: 6, location: 'VIP' }
];
